import { render } from "./ReviewersTab.vue?vue&type=template&id=787b078c&scoped=true"
import script from "./ReviewersTab.vue?vue&type=script&lang=js"
export * from "./ReviewersTab.vue?vue&type=script&lang=js"

import "./ReviewersTab.vue?vue&type=style&index=0&id=787b078c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787b078c"]])

export default __exports__